import React from 'react'
import ReactPlayer from 'react-player'
import appSettings from '@/appsettings.json';
import {
	MediaController,
	MediaControlBar,
	MediaTimeRange,
	MediaTimeDisplay,
	MediaVolumeRange,
	MediaPlaybackRateButton,
	MediaPlayButton,
	MediaSeekBackwardButton,
	MediaSeekForwardButton,
	MediaMuteButton,
	MediaFullscreenButton,
} from "media-chrome/react";

type VideoPlayerProps = {
	id: string,
	width: string,
	type: string, // performance/feedback
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ id, width, type }) => {
	return (
		<MediaController
			style={{
				width: width,
				aspectRatio: "16/9",
				borderRadius: "20px"
			}}
		>
			<ReactPlayer
				slot="media"
				src={type == "performance" ? `${appSettings.S3BucketBaseUrl}SubmissionVideos/${id}.mp4` :
					`${appSettings.S3BucketBaseUrl}FeedbackVideos/${id}.mp4`}
				controls={false}
				style={{
					width: "100%",
					height: "100%",
					borderRadius: "20px"
				}}
			></ReactPlayer>
			<MediaControlBar
				style={{
					borderRadius: "20px"
				}}
			>
				<MediaPlayButton
					style={{
						borderRadius: "20px"
					}}
				/>
				<MediaSeekBackwardButton seekOffset={10} />
				<MediaSeekForwardButton seekOffset={10} />
				<MediaTimeRange />
				<MediaTimeDisplay showDuration />
				<MediaMuteButton />
				<MediaVolumeRange />
				<MediaPlaybackRateButton />
				<MediaFullscreenButton
					style={{
						borderRadius: "20px"
					}}
				/>
			</MediaControlBar>
		</MediaController>
	)
}

export default VideoPlayer;